import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';

const HouseRulesPage: React.FC = () => {
  const rules = [
    { 
      title: 'Check-in and Check-out', 
      content: 'Check-in time is from 2:00 PM to 10:00 PM. Check-out time is by 12:00 PM. Early check-in or late check-out may be available upon request, subject to availability.',
      type: 'info'
    },
    { 
      title: 'Quiet Hours', 
      content: 'Please respect quiet hours between 10:00 PM and 8:00 AM to ensure a peaceful stay for all guests.',
      type: 'rule'
    },
    { 
      title: 'No Smoking', 
      content: 'Smoking is strictly prohibited inside the homestay. Designated smoking areas are available outside.',
      type: 'prohibited'
    },
    { 
      title: 'No Parties or Events', 
      content: 'Parties, events, or gatherings with outside guests are not permitted without prior approval.',
      type: 'prohibited'
    },
    { 
      title: 'Pets', 
      content: 'Sorry, pets are not allowed in the homestay to ensure comfort for all guests and maintain cleanliness.',
      type: 'prohibited'
    },
    { 
      title: 'Damage and Breakage', 
      content: 'Guests are responsible for any damage or breakage caused during their stay. Please report any issues immediately.',
      type: 'rule'
    },
    { 
      title: 'Cleanliness', 
      content: 'Please keep the homestay clean and tidy. Dispose of trash in designated bins and clean up after using common areas.',
      type: 'rule'
    },
    { 
      title: 'Security', 
      content: 'Always lock doors and windows when leaving the homestay. We are not responsible for lost or stolen items.',
      type: 'rule'
    },
    { 
      title: 'Utilities', 
      content: 'Please conserve energy by turning off lights, air conditioning, and other appliances when not in use.',
      type: 'rule'
    },
    { 
      title: 'Parking', 
      content: 'Free parking is available on the premises. Please park only in designated areas.',
      type: 'info'
    }
  ];

  return (
    <Layout>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">House Rules</h1>
        <p className="text-gray-600 mb-8">
          To ensure a pleasant stay for all our guests, we kindly ask you to observe the following rules during your stay at Mikhael Homestay.
        </p>
        
        <div className="space-y-6">
          {rules.map((rule, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-md">
              <div className="flex items-start">
                <div className="flex-shrink-0 mt-1">
                  {rule.type === 'prohibited' ? (
                    <FaTimesCircle className="h-5 w-5 text-red-500" />
                  ) : (
                    <FaCheckCircle className="h-5 w-5 text-green-500" />
                  )}
                </div>
                <div className="ml-3">
                  <h3 className={`text-lg font-medium ${
                    rule.type === 'prohibited' ? 'text-red-800' : 
                    rule.type === 'rule' ? 'text-blue-800' : 'text-gray-800'
                  }`}>
                    {rule.title}
                  </h3>
                  <p className="mt-1 text-gray-600">{rule.content}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">
            Thank you for your cooperation and understanding. We hope you enjoy your stay!
          </p>
          <Link
            to="/"
            className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700"
          >
            Return to Home
          </Link>
        </div>
      </div>
    </Layout>
  );
};

export default HouseRulesPage;
